import { __assign, __rest } from "tslib";
import React from 'react';
import { useSelectByTheme } from '@wix/da-react-context/pkg/ThemeContext';
/** helper component for when an image needs to change based on theme */
var ThemedImg = function (_a) {
    var srcDark = _a.srcDark, srcLight = _a.srcLight, _b = _a.srcGreen, srcGreen = _b === void 0 ? srcLight : _b, props = __rest(_a, ["srcDark", "srcLight", "srcGreen"]);
    var src = useSelectByTheme({
        dark: srcDark,
        light: srcLight,
        green: srcGreen,
    });
    return React.createElement("img", __assign({ src: src, alt: "" }, props));
};
ThemedImg.displayName = 'ThemedImg';
export default ThemedImg;
//# sourceMappingURL=ThemedImg.js.map